export default function FormField({
    label,
    id,
    name,
    type = "text",
    value,
    onChange,
    onKeyDown,
    required,
    placeholder,
    autoComplete = "off",
    className = "",
    error,
    readOnly = false,
    min,
    max,
}) {
    return (
        <div className={`d-flex flex-column align-items-start mb-3 ${className}`}>
            <label htmlFor={id || name} className="form-label ps-1">
                {label}
                {required && <span style={{ color: "red" }}> *</span>}
            </label>

            <input
                type={type}
                id={id || name}
                name={name}
                autoComplete={autoComplete}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                required={required}
                placeholder={placeholder}
                readOnly={readOnly}
                min={min}
                max={max}
                className={`form-control ${error ? "is-invalid" : ""}`}
                style={{
                    backgroundColor: readOnly ? "#f9fafb" : "white",
                    color: readOnly ? "#6c757d" : "inherit",
                    cursor: readOnly ? "not-allowed" : "text",
                    borderColor: readOnly ? "#e3e3e3" : undefined,
                }} />

            {error && <div className="invalid-feedback">{error}</div>}
        </div>
    );
}